/**
 * Micro Degree API
 *
 * @author sohyun.ahn@emcast.com
 */
import httpService from "@/api/httpService";

const microDegreeApi = {
  // 스킬패스 수강 신청 조회
  getRegistedDegree(params) {
    return httpService.get(`/micro/learn/online/registration/degree/${params.degreeId}`)
  },

  // 스킬패스 수강 신청
  postRegistDegree(params) {
    return httpService.post(`/micro/learn/online/registration/degree/${params.degreeId}`)
  },

   // 기간정책(Get degree period information)
  getPeriod(params) {
    return httpService.get(`/micro/learn/online/${params.degreeId}/policy/period`)
  },

  // 수료정책(Get degree completion information)
  guestLearnOnlineViewCompletion(params) {
    return httpService.get(
      `/micro/learn/online/${params.degreeId}/policy/completion`
    );
  },

  // 포인트(Get degree point information)
  guestLearnOnlineViewPoint(params) {
    return httpService.get(
      `/micro/learn/online/${params.degreeId}/policy/point`
    );
  },

  // 리뷰 요약(Get degree review summary)
  guestLearnOnlineViewReviewSummary(params) {
    return httpService.get(
      `/micro/learn/online/${params.degreeId}/review/summary`
    );
  },

  // 배지 목록(Get degree badges list)
  guestLearnOnlineViewBadges(params) {
    return httpService.get(
      `/micro/learn/online/${params.degreeId}/badges?fetchType=DEGREE`
    );
  },
  
  //Recomnded Degree list
  fetchRecommendedList(params) {
    return httpService.get(
      `/micro/learn/online/target?type=RECOMMENDABLE`,
      params
    );
  },

  // 리뷰 목록(Get degree review list)
  learnOnlineViewReview(params) {
    return httpService.get(
      `/micro/learn/online/${params.degreeId}/review`,
      params
    );
  },

  // 리뷰 목록(post review)
  learnPostReview(params) {
    return httpService.post(
      `/micro/learn/online/${params.degreeId}/review`,
      params
    );
  },

  // 리뷰 수정(edit review)
  learnPostReviewEdit(params) {
    return httpService.put(
        `/micro/learn/online/${params.degreeId}/review/${params.id}`,
        params
    );
  },

  // 리뷰 목록(get review by Id)
  learnGetReview(params) {
    return httpService.get(
      `/micro/learn/online/${params.degreeId}/review/${params.id}`
    );
  },

  // 리뷰 목록(get review by Id)
  learnEditReview(params) {
    return httpService.put(
      `/micro/learn/online/${params.degreeId}/review`,
      params
    );
  },

  // 리뷰 좋아요(like review)
  learnLikeReview(params) {
    return httpService.post(
        `/micro/learn/online/${params.degreeId}/review/${params.reviewId}/like`,
        params
    );
  },

  // 리뷰 좋아요 취소(unlike review)
  learnUnlikeReview(params) {
    return httpService.delete(
        `/micro/learn/online/${params.degreeId}/review/${params.reviewId}/like`,
        params
    );
  },

  //(delete review by Id)
  learnDeleteReview(params) {
    return httpService.delete(
      `/micro/learn/online/${params.degreeId}/review/${params.reviewId}`
    );
  },

  learnReportReview(params) {
    return httpService.post(
        `/micro/learn/online/${params.degreeId}/review/${params.reviewId}/report`, params
    );
  },

  //(Review Registration Auth)
  authPermission(params) {
    return httpService.get(
      `/micro/learn/online/${params.degreeId}/review/authRegistration`
    );
  }
};

// export const
export default microDegreeApi;
